export default "__VITE_ASSET__CEJESCbq__"